const getBrowserLanguage = () => {
  const language = navigator.language || navigator.userLanguage;
  return language.split("-")[0]; // Return the language code (e.g., 'en', 'de', 'ru')
};

export default getBrowserLanguage;
